import { InputText } from '@te-whatu-ora/anatomic'
import type { StringInputProps } from '@healthnz-prm/fhir-engine-renderer/types'
import { useAdditionalLabelProperties } from '@/components/fhirEngine/utils/additionalProperties'
import { ChangeEvent } from 'react'
import { RequiredInputWrapper } from '@/components/fhirEngine/utils/requiredLabel'

export default function StringInput(props: StringInputProps) {
  const {
    inputId,
    onChange,
    onFocus,
    error,
    helperText,
    onBlur,
    value,
    disabled,
    labelComponent,
    required,
    maxLength
  } = props

  function handleChange(event: ChangeEvent<HTMLInputElement>) {
    const newValue = event.target.value

    if (maxLength !== undefined && newValue.length > maxLength) {
      onChange(newValue.slice(0, maxLength) || null)
      return
    }

    onChange(newValue || null)
  }

  const currentLength = value?.length ?? 0
  const characterCount =
    maxLength !== undefined
      ? `Maximum ${maxLength} characters — ${currentLength} used`
      : undefined

  const maxLengthReached =
    maxLength !== undefined && currentLength >= maxLength
      ? `Maximum ${maxLength} characters — ${maxLength} used`
      : undefined

  const displayError = error ?? maxLengthReached
  const displayHelperText = displayError
    ? undefined
    : helperText ?? characterCount

  const additionalProps = useAdditionalLabelProperties(props)

  return (
    <RequiredInputWrapper
      inputId={inputId}
      labelComponent={labelComponent}
      required={required}
    >
      <InputText
        {...additionalProps}
        disabled={disabled}
        errorMessage={displayError}
        helperText={displayHelperText}
        maxLength={maxLength}
        name={inputId}
        onBlur={onBlur}
        onChange={handleChange}
        onFocus={onFocus}
        type='text'
        value={value ?? undefined}
      />
    </RequiredInputWrapper>
  )
}
